import React from 'react';
import '../../styles/CustomTextarea.css';

function CustomTextarea({
  placeholder,
  value,
  onChange,
  label,
  name,
  width,
  height,
  message,
  isNotMarginMessage,
  restrictTextInput,
  maxLength,
  ...rest
}) {
  const textareaStyle = {
    width: width,
    height: height,
    margin: message ? 0 : 'initial',
  };

  const handleInputChange = (event) => {
    if (restrictTextInput) {
      const newValue = event.target.value;
      const regex = /^[0-9.,;\s-]*$/;
      if (!regex.test(newValue)) {
        event.preventDefault();
        return;
      }
    }
    onChange(event);
  };

  const handleBeforeInput = (event) => {
    if (restrictTextInput) {
      const charStr = event.data;

      // Разрешаем только цифры, запятую, точку с запятой, пробел и дефис
      if (charStr && !/[0-9.,;\s-]/.test(charStr)) {
        event.preventDefault();
      }
    }
  };

  return (
    <>
      <div className="textarea-container" style={textareaStyle}>
        {label && (
          <label className="textarea-label" htmlFor={name}>
            {label}
          </label>
        )}
        <textarea
          {...rest}
          className={`custom-textarea ${rest?.className}`}
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
          onBeforeInput={handleBeforeInput}
          name={name}
          id={name}
          maxLength={maxLength}
          style={{ ...textareaStyle, ...(rest?.style || {}) }}
        />
        {message && (
          <span className={`message-text-input ${message ? 'visible black-text' : ''}`}>
            {message}
          </span>
        )}
      </div>
    </>
  );
}

export default CustomTextarea;
